import {
  HttpClient,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class BoardsService {
  public hostUrl: any = environment.API_BASE_URL;

  public urlToGetBoardsList: any = this.hostUrl + 'api/getBoards';
  public urlToGetBoardById: any = this.hostUrl + 'api/getBoardById';
  public urlToGetAdminBoardById: any = this.hostUrl + 'api/getAdminBoards';

  constructor(private _http: HttpClient) {}

  public getBoardsList(): Observable<any> {
    return this._http.get(this.urlToGetBoardsList).map((res: Response) => res);
  }

  public getBoardById(data: any): Observable<any> {
    return this._http.post(this.urlToGetBoardById, data).map((res: Response) => res);
  }
  public getAdminBoardById(data: any): Observable<any> {
    return this._http.post(this.urlToGetAdminBoardById, data).map((res: Response) => res);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/main/boards.service.ts